import { render, staticRenderFns } from "./CustomerAccept.vue?vue&type=template&id=52b210c0&"
import script from "./CustomerAccept.vue?vue&type=script&lang=js&"
export * from "./CustomerAccept.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports